var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "time",
    {
      attrs: {
        title: _vm.exactDate,
        datetime: _vm.date,
        "data-component": "UiRelativeDate",
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.relativeDate) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }